if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification'); // keep this
      this.submitButton = this.querySelector('[type="submit"]');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const disclaimerCheck = document.querySelector('#custom-disclaimer');
      if (disclaimerCheck?.required && !disclaimerCheck.checked) {
        this.handleErrorMessage("Please read and confirm details below");
        return;
      }

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.main-atc-spinner')?.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);

      // ✅ Important: tell Shopify which sections to re-render for the popup
      if (this.cart && this.cart.getSectionsToRender) {
        const sectionIds = this.cart.getSectionsToRender().map(s => s.id).join(',');
        formData.append('sections', sectionIds);
        formData.append('sections_url', window.location.pathname);
      }

      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((res) => res.json())
        .then((response) => {
          // Error from /cart/add.js
          if (response.status) {
            this.handleErrorMessage(response.description);
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (soldOutMessage) {
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
            this.error = true;
            return;
          }

          // ✅ Render and open the cart notification popup
          if (this.cart && this.cart.renderContents) {
            this.cart.renderContents(response);
          }

          // Fire your other updates
          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
          this.error = false;

          updateCartCountBubble();
          document.body.classList.remove('overflow-hidden');
          // optional: keep or remove this scroll
          // window.scrollTo({ top: 0, behavior: 'smooth' });
        })
        .catch((e) => console.error(e))
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.querySelector('.main-atc-spinner')?.classList.add('hidden');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
        this.errorMessage.scrollIntoView({ block: 'center' });
      }
    }
  });
}

// Re-usable cart count updater (unchanged)
function updateCartCountBubble() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const count = cart.item_count;

      // Find the bubble wrapper (prefer explicit hook, then fallbacks)
      const bubble =
        document.querySelector('[data-cart-count-bubble]') ||
        document.querySelector('#cart-icon-bubble .cart-count-bubble') ||
        document.querySelector('#dawn13-cart-icon-bubble .cart-count-bubble') ||
        document.querySelector('.header__icon--cart .cart-count-bubble') ||
        document.querySelector('.cart-count-bubble');

      if (!bubble) {
        console.warn('[Cart Count] Bubble element not found. Add data-cart-count-bubble to your bubble wrapper.');
        return;
      }

      // Prefer the numeric span so we don't clobber the screen-reader span
      const numericSpan = bubble.querySelector('span[aria-hidden="true"]') || bubble;

      numericSpan.textContent = count > 0 ? String(count) : '';
      bubble.classList.toggle('hidden', count === 0);

      // Keep ARIA correct if we're using the wrapper directly
      if (numericSpan === bubble) {
        bubble.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
      }
    })
    .catch(err => console.warn('[Cart Count] Failed to update:', err));
}